import { JobClosedMessage } from './JobClosedMessage';

export const JobClosedPage: React.FC = () => (
  <div className="application-step-two-container">
    <div className="flex application-container">
      <div className="flex-3">
        <JobClosedMessage showBackToDashboardButton />
      </div>
    </div>
  </div>
);
